import React, { useState } from "react";

import {
  Grid,
  CircularProgress,
  Typography,
  Button,
  Fade,
  Card,
  InputBase,
  InputAdornment,
  Container,
} from "@material-ui/core";

import { withRouter, Link, useHistory } from "react-router-dom";
import classnames from "classnames";

// styles
import useStyles from "./styles";

// logo
import Logo from "../../assets/img/logo.svg";

import AppImg from "../../assets/img/logo.svg";

import SuccessIcon from "@material-ui/core/InputAdornment";
import CloseIcon from "@material-ui/core/InputAdornment";

//import PageTitle from "../../components/PageTitle";
import PasswordIcon from "@material-ui/core/InputAdornment";
import { withSnackbar } from "../../components/Message/Alert";

// context
import { useUserDispatch, changePassword } from "../../context/UserContext";
function UpdatePassword({ ...props }) {
  var classes = useStyles();
  const { showMessage } = props;
  const history = useHistory();
  // global
  var userDispatch = useUserDispatch();
  // local
  var [isLoading, setIsLoading] = useState(false);
  var [error, setError] = useState(null);
  var [oldPasswordValue, setOldPasswordValue] = useState("");
  var [newPasswordValue, setNewPasswordValue] = useState("");
  var [confirmPasswordValue, setConfirmPasswordValue] = useState("");

  var [passwordMatch, setPasswordMatch] = useState(true);
  var [isSuccess, setIsSuccess] = useState(false);
  var [returnMessage, setReturnMessage] = useState("");
  const [title, setTitle] = useState("Change Password");

  // New -------------

  var [isPasswordPatternMatch, setIsPasswordPatternMatch] = useState(false);
  var [passwordPatternMessage, setPasswordPatternMessage] = useState();
  const [passwordStrength, setPasswordStrength] = useState("strong");

  // New -------------

  const onBlurNewPassword = (event) => {
    // check without numeric number
    if (
      newPasswordValue &&
      !/^(?=.*?[A-Z])(?=.*?[a-z])(?=.)(?=.*?[#?!@$%^&*-]).{8,}$/i.test(
        newPasswordValue
      )
    ) {
      setIsPasswordPatternMatch(false);
      setPasswordPatternMessage(
        "Password must contain at least 8 characters including upper/lower case and a special character."
      );
    } else setIsPasswordPatternMatch(true);
  };

  const onBlurConfPassword = (event) => {
    if (newPasswordValue != confirmPasswordValue) {
      setPasswordMatch(false);
    } else {
      setPasswordMatch(true);
    }
  };
  const goToDashboard = () => {
    setTimeout(() => {
      history.push("/app/dashboard");
    }, 3000);
    };
    if (isSuccess) {
        showMessage("Success", "Success! Your password has been updated successfully.", "success", 2000);
        setTimeout(() => { history.push('/app/dashboard') }, 2000);
    }

    const onFocusConfPassword = () => {

        setPasswordMatch(true);
    }
    const showSuccessMessage = () => {
       
    }

  return (
    <>
      <div className="reset-password-main">
        <div className="reset-password-form-area">
          <div className="reset-password-left-panel">
            <div className="reset-password-form-custom">
              <div className="login-logo">
                <img alt="logo" src={Logo} />
              </div>
              
                <Grid
                  container
                  direction="row"
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                >
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    className={classes.formContainer}
                    container
                    direction="row"
                    justify="flex-start"
                    align="flex-start"
                  >
                    <div className={classes.form}>
                      <React.Fragment>
                        <Grid
                          className={classes.inBox}
                          container
                          direction="row"
                          align="left"
                        >
                        

                          <InputBase
                            id="oldPassword"
                            value={oldPasswordValue}
                            className={classes.textField}
                            onChange={(e) =>
                              setOldPasswordValue(e.target.value)
                            }
                            margin="none"
                            placeholder="Old Password"
                            type="password"
                            fullWidth
                            required
                          />

                          <InputBase
                            id="NewPassword"
                            value={newPasswordValue}
                            className={classes.textField}
                            onChange={(e) =>
                              setNewPasswordValue(e.target.value)
                            }
                            margin="none"
                            placeholder="New Password"
                            type="password"
                            onFocus={() => setIsPasswordPatternMatch(false)}
                            onBlur={onBlurNewPassword}
                            fullWidth
                            required
                          />

                          {!isPasswordPatternMatch ? (
                            <Fade in={!isPasswordPatternMatch}>
                              <span
                                className="error-message"
                              >
                                {passwordPatternMessage}
                              </span>
                            </Fade>
                          ) : (
                            ""
                                              )}
                                              <InputBase
                                                  id="confirmPassword"
                                                  value={confirmPasswordValue}
                                                  className={classes.textField}
                                                  onChange={(e) =>
                                                    setConfirmPasswordValue(e.target.value)
                                                  }
                                                  margin="none"
                                                  placeholder="Confirm Password"
                                                  type="password"
                                                  onBlur={onBlurConfPassword}
                                                  onFocus={onFocusConfPassword}
                                                  fullWidth
                                                  required
                                              />
                                              {!passwordMatch && confirmPasswordValue != "" && !error ? (
                            <Fade
                              in={!passwordMatch && confirmPasswordValue != ""}
                            >
                              <span
                                 className="error-message"
                              >
                                Password does not match
                              </span>
                            </Fade>
                          ) : (
                            ""
                          )}

                          {error ? (
                            <Fade in={error}>
                              <span
                              className="error-message"
                              >
                                {returnMessage}
                                                      </span>
                            </Fade>
                          ) : (
                            ""
                          )}

                          {isSuccess ? (
                            <Fade in={isSuccess}>
                              <span className={classes.successMessage}>
                                {returnMessage}
                              </span>
                            </Fade>
                          ) : (
                            ""
                          )}

                          <div className={classes.formButtons}>
                            {isLoading ? (
                              <CircularProgress
                                size={26}
                                className={classes.loginLoader}
                              />
                            ) : (
                              <Button
                                disabled={
                                  oldPasswordValue.length === 0 ||
                                  newPasswordValue.length === 0 ||
                                  confirmPasswordValue.length === 0
                                }
                                onClick={() =>
                                  changePassword(
                                    userDispatch,
                                    oldPasswordValue,
                                    newPasswordValue,
                                    confirmPasswordValue,
                                    props.history,
                                    setIsLoading,
                                    setError,
                                    setIsSuccess,
                                    setReturnMessage
                                  )
                                }
                                className={classes.loginBtn}
                                size="large"
                              >
                                Change Password
                              </Button>
                            )}
                          </div>
                        </Grid>
                      </React.Fragment>
                    </div>
                  </Grid>
                </Grid>
             
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default withSnackbar(UpdatePassword);
